import { JSX } from "react";

export const FormatUsersUnderline2 = ({
  className,
  ...props
}: JSX.IntrinsicElements["svg"]) => {
  return (
    <svg
      viewBox="0 0 111 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M6 8C36.8595 2.50566 70.0507 10.5462 105 6.25789"
        stroke="#CFB2FF"
        strokeWidth="12"
        strokeLinecap="round"
      />
    </svg>
  );
};
